import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import About from "@/pages/About";

export const Route = createFileRoute("/en/about-qbd/")({
  head: () => buildRouteHead("/en/about-qbd"),
  component: About,
});

